<template>
  <div class="p-8">
    <form @submit.prevent="add">
      <div class="flex pt-4 border-t">
        <div class="w-1/3">
          <h3 class="font-semibold uppercase text-gray-600 text-xl">
            New Corporate
          </h3>
          <p class="text-gray-600">Add a new corporate account!</p>
        </div>
        <div class="w-2/3">
          <div class="flex space-x-4">
            <label class="block w-1/2">
              <span class="text-gray-700">Name</span>
              <input
                v-model="name"
                class="form-input block w-full"
                placeholder="Sheraton Addis"
              />
            </label>
            <label class="block w-1/2">
              <span class="text-gray-700">Short Name</span>
              <input
                v-model="shortName"
                minlength="3"
                maxlength="3"
                class="form-input block w-full rounded-l-none"
                placeholder="SHR"
              />
            </label>
          </div>
          <div class="mt-4">
            <button
              :disabled="busy"
              class="w-32 py-2 text-ilift-900 rounded shadow"
              :class="
                busy
                  ? 'bg-ilift-200 cursor-not-allowed'
                  : 'bg-ilift-500 hover:bg-ilift-600'
              "
            >
              Add
            </button>
          </div>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
export default {
  data() {
    return {
      busy: false,
      name: "",
      shortName: ""
    };
  },
  methods: {
    add() {
      if (this.name && this.shortName && this.shortName.length == 3) {
        this.busy = true;
        this.$http
          .post("/corporates", {
            name: this.name,
            shortName: this.shortName.toLowerCase()
          })
          .then(() => this.$router.push("/corporate"))
          .catch(err => console.log(err))
          .finally(() => (this.busy = false));
      }
    }
  }
};
</script>
